import { useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export default function BeforeAfter({ before, after, alt = "" }) {
  const [pos, setPos] = useState(50);

  return (
    <div data-testid="before-after-slider" className="relative select-none overflow-hidden border border-line">
      <img src={after} alt={`${alt} 施工後`} draggable={false} className="block aspect-[16/9] w-full object-cover" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={`${alt} 施工前`} draggable={false} className="block h-full w-full object-cover" />
      </div>
      <div className="pointer-events-none absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="h-full w-0.5 -translate-x-1/2 bg-accent" />
        <div className="absolute top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center bg-accent text-ink">
          <ChevronsLeftRight className="h-5 w-5" />
        </div>
      </div>
      <span className="pointer-events-none absolute left-4 top-4 bg-ink/80 px-3 py-1 font-mono text-[10px] font-bold tracking-[0.25em] text-white">
        BEFORE
      </span>
      <span className="pointer-events-none absolute right-4 top-4 bg-accent px-3 py-1 font-mono text-[10px] font-bold tracking-[0.25em] text-ink">
        AFTER
      </span>
      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        data-testid="before-after-range"
        aria-label="施工前後の比較スライダー"
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
      />
    </div>
  );
}
